import React from "react";
import { Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { formatIsoDateToLocale } from "@pulse-ui/formatting";
import { OrganizationHeaderProps } from "./OrganizationHeader.types";

/**
 * OrganizationHeader component
 * Displays organization information and provides "Add Entity" button
 */
export const OrganizationHeader: React.FC<OrganizationHeaderProps> = ({
    orgData,
    onAddEntity,
}) => {
    return (
        <>
            <p className="pulse-typography-headline-6 pulse-color--background-50 pulse-row pulse-mb-1">
                Entity Management
            </p>

            <div
                className="
                    pulse-row
                    entity-management-header-row
                    entity-management-position-relative
                    pulse-col-md-12
                    pulse-col-lg-12
                    pulse-col-xl-12
                    pulse-p-1
                    pulse-bg-color--background-800
                    pulse-mb-3
                "
            >
                <div className="entity-management-header-section-1 pulse-mb-2">
                    <p className="pulse-typography-headline-5 pulse-color--background-50">
                        {orgData?.display_name
                            ? `Organization: ${orgData.display_name}`
                            : "Organization"}
                    </p>

                    {orgData && (
                        <div className="entity-management-active-status pulse-typography-headline-6">
                            {orgData.is_active ? (
                                <>
                                    <CheckCircleIcon className="entity-management-active-status-active-icon pulse-mr-1" />
                                    <p className="pulse-color--success-700">Active</p>
                                </>
                            ) : (
                                <>
                                    <ErrorIcon className="entity-management-active-status-error-icon pulse-mr-1" />
                                    <p className="pulse-color--error-700">Not Active</p>
                                </>
                            )}
                        </div>
                    )}
                </div>

                <div className="entity-management-header-section-2">
                    <div className="entity-management-header-section-2-subsection-1">
                        {orgData && (
                            <p className="pulse-typography-subtitle-1 pulse-color--background-100 pulse-mb-1">
                                {`Created: ${formatIsoDateToLocale(orgData.created || "")}`}
                            </p>
                        )}

                        {orgData && (
                            <p className="pulse-typography-subtitle-1 pulse-color--background-100">
                                {`Last Modified: ${formatIsoDateToLocale(orgData.last_modified || "")}`}
                            </p>
                        )}
                    </div>

                    <div className="entity-management-header-section-2-subsection-2">
                        <Button onClick={() => onAddEntity()}>Add Entity</Button>
                    </div>
                </div>
            </div>

            <hr
                className="entity-management-position-relative pulse-mb-2"
                style={{ borderColor: "#627195" }}
            />
        </>
    );
};
